import {autoRegister, resolve} from "../container";
import {GLOBAL} from "./globals";
import {customElement, property} from "lit/decorators.js";
import {UnLitElement} from "./elements";
import {html, type TemplateResult} from "lit";
import {EopErrorHandler} from "./errorHandler";
import type {Nullable} from "../bootstrap/common/types";

export const SVG_SPRITE_MAP_PATH_META_TAG_ID = "svg-sprite-map-path";

@autoRegister()
export class SvgSpriteMap {
    private svgSpritePath: string;

    public constructor(private errorHandler: EopErrorHandler = resolve(EopErrorHandler)) {
    }

    public resolvePath(): string {
        if (!this.svgSpritePath) {
            const svgSpriteMapPath = GLOBAL.headElement()
                .querySelector<HTMLMetaElement>(`meta[name="${SVG_SPRITE_MAP_PATH_META_TAG_ID}"]`);
            if (svgSpriteMapPath) {
                this.svgSpritePath = svgSpriteMapPath.content;
            } else {
                this.errorHandler.report("Missing SVG sprite map path meta tag!");
            }
        }
        return this.svgSpritePath;
    }
}

@customElement("eop-svg-sprite-icon")
export class SvgSpriteIcon extends UnLitElement {
    @property({attribute: "icon-id", type: String})
    public iconId: string;
    @property({attribute: "label", type: String})
    public label: string;
    @property({attribute: "symbol-class", type: String})
    public symbolClass: string;

    public constructor(private svgSpriteMap: SvgSpriteMap = resolve(SvgSpriteMap)) {
        super();
    }

    public render(): TemplateResult {
        const svgClasses = this.symbolClass ? `svg-pictogram ${this.symbolClass}` : "svg-pictogram";
        return html`
            <svg class=${svgClasses}>
                <use href="${this.svgSpriteMap.resolvePath()}#${this.iconId}">${this.renderTitle()}</use>
            </svg>
        `;
    }

    private renderTitle(): Nullable<TemplateResult> {
        if (this.label) {
            return html`<title>${this.label}</title>`;
        }
        return null;
    }
}